import Cookies from 'js-cookie';
import { datadogRum } from '@datadog/browser-rum';
import _get from 'lodash.get';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var config = {};
/**
 * convenience method to extend the config object.
 * @param defaults
 * @param options
 */
function mergeGlobalOptions(options) {
    if (options.apiBaseUrl) {
        var url = new URL(options.apiBaseUrl);
        options.apiBaseUrl = url.origin + '/v3/';
    }
    return (config = __assign(__assign({}, config), options));
}
var configure = mergeGlobalOptions;

var defaultHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
};
var RequestTypes;
(function (RequestTypes) {
    RequestTypes["Get"] = "GET";
    RequestTypes["Post"] = "POST";
    RequestTypes["Put"] = "PUT";
    RequestTypes["Patch"] = "PATCH";
    RequestTypes["Delete"] = "DELETE";
})(RequestTypes || (RequestTypes = {}));
function addAuthHeader(authToken) {
    defaultHeaders = __assign(__assign({}, defaultHeaders), {
        Authorization: "token " + authToken,
    });
}
function tryGetAuthTokenFromCookie() {
    var authToken = Cookies.get('mako_auth_token');
    return authToken;
}
function setHeaders() {
    if (!defaultHeaders.Authorization) {
        var token = tryGetAuthTokenFromCookie();
        if (token) {
            addAuthHeader(token);
        }
    }
    return defaultHeaders;
}
function buildRequest(requestType, body, requestOptions) {
    var request = {};
    var headers = setHeaders();
    if (requestOptions) {
        if (requestOptions.headers) {
            headers = __assign(__assign({}, headers), requestOptions.headers);
        }
        request = __assign({}, requestOptions);
    }
    request.headers = headers;
    request.method = requestType;
    if (body) {
        request.body = JSON.stringify(body);
    }
    return request;
}
function makeRequest(baseUri, uri, request) {
    if (baseUri === void 0) { baseUri = config.apiBaseUrl; }
    var url = "" + baseUri + uri;
    return fetch(url, request);
}
/**
 * Wrapper for the HTTP GET method
 * Requires the Return Type as the generic parameter
 * @param apiEndpoint - API Endpoint to hit
 * @param requestOptions - request options to override
 * @param baseUrl - optional parameter to change the root of the API being hit, defaults to MAKO API
 */
function get(apiEndpoint, requestOptions, baseUrl) {
    var request = buildRequest(RequestTypes.Get, undefined, requestOptions);
    return makeRequest(baseUrl, apiEndpoint, request);
}
/**
 * Wrapper for the HTTP POST method
 * Requires the Return Type as the generic parameter
 * @param apiEndpoint - API Endpoint to hit
 * @param body - json body to post
 * @param requestOptions - request options to override
 * @param baseUrl - optional parameter to change the root of the API being hit, defaults to MAKO API
 */
function post(apiEndpoint, body, requestOptions, baseUrl) {
    var request = buildRequest(RequestTypes.Post, body, requestOptions);
    return makeRequest(baseUrl, apiEndpoint, request);
}
/**
 * Wrapper for the HTTP PUT method
 * Requires the Return Type as the generic parameter
 * @param apiEndpoint - API Endpoint to hit
 * @param body - json body to post
 * @param requestOptions - request options to override
 * @param baseUrl - optional parameter to change the root of the API being hit, defaults to MAKO API
 */
function put(apiEndpoint, body, requestOptions, baseUrl) {
    var request = buildRequest(RequestTypes.Put, body, requestOptions);
    return makeRequest(baseUrl, apiEndpoint, request);
}
/**
 * Wrapper for the HTTP DELETE method
 * Requires the Return Type as the generic parameter
 * @param apiEndpoint - API Endpoint to hit
 * @param body - json body to post
 * @param requestOptions - request options to override
 * @param baseUrl - optional parameter to change the root of the API being hit, defaults to MAKO API
 */
function del(apiEndpoint, body, requestOptions, baseUrl) {
    var request = buildRequest(RequestTypes.Delete, body, requestOptions);
    return makeRequest(baseUrl, apiEndpoint, request);
}
/**
 * Wrapper for the MOCK HTTP method
 * Requires the Return Type as the generic parameter
 * @param apiEndpoint - API Endpoint to hit
 * @param body - json body to post
 * @param baseUrl - optional parameter to change the root of the API being hit, defaults to MAKO API
 */
function mock(apiEndpoint, body, baseUri) {
    var mockPromise = Promise.resolve({
        json: function () { return Promise.resolve({}); },
    });
    return mockPromise;
}
var http = {
    get: get,
    post: post,
    put: put,
    del: del,
    mock: mock,
    addAuthHeader: addAuthHeader,
};

function getUserAccount() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('user/account')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load user profile');
            }
        });
    });
}
function getUsername() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('user/username')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load username');
            }
        });
    });
}
function getFeatureToggles() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('feature_toggles')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load feature toggles');
            }
        });
    });
}
function getSignupStatus() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('s2s/signup/status')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load sign up status');
            }
        });
    });
}
function getUserPackage() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('user/package')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load user package');
            }
        });
    });
}
function getScopes() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('scopes')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load scopes');
            }
        });
    });
}
function getOesAccount() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('accounts/offerings?_show&_pricing&_offerings')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load OES account');
            }
        });
    });
}
function getApiKeys() {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get('api_keys')];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load api keys');
            }
        });
    });
}
function getApiKey(apiKeyId) {
    return __awaiter(this, void 0, Promise, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, http.get("api_keys/" + apiKeyId)];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, (_a.sent())];
                case 3: throw new Error('Failed to load api key');
            }
        });
    });
}
var api = {
    getUserAccount: getUserAccount,
    getUsername: getUsername,
    getFeatureToggles: getFeatureToggles,
    getSignupStatus: getSignupStatus,
    getUserPackage: getUserPackage,
    getScopes: getScopes,
    getOesAccount: getOesAccount,
    getApiKeys: getApiKeys,
    getApiKey: getApiKey,
};

var ProductId;
(function (ProductId) {
    ProductId["SG_DISCOUNT_COMMDEV_TIER_1_V1"] = "sg.discount.commdev-tier-1.v1";
    ProductId["SG_DISCOUNT_COMMDEV_TIER_2_V1"] = "sg.discount.commdev-tier-2.v1";
    ProductId["SG_DISCOUNT_COMMDEV_TIER_3_V1"] = "sg.discount.commdev-tier-3.v1";
    ProductId["SG_EI_BRONZE_V1"] = "sg.ei.bronze.v1";
    ProductId["SG_EI_ESSENTIALS_100K_V1"] = "sg.ei.essentials-100k.v1";
    ProductId["SG_EI_ESSENTIALS_100K_V2"] = "sg.ei.essentials-100k.v2";
    ProductId["SG_EI_ESSENTIALS_40K_V1"] = "sg.ei.essentials-40k.v1";
    ProductId["SG_EI_ESSENTIALS_40K_V2"] = "sg.ei.essentials-40k.v2";
    ProductId["SG_EI_ESSENTIALS_SUMMARY_V1"] = "sg.ei.essentials-summary.v1";
    ProductId["SG_EI_FREE_100_V1"] = "sg.ei.free-100.v1";
    ProductId["SG_EI_FREE_12K_V1"] = "sg.ei.free-12k.v1";
    ProductId["SG_EI_FREE_SUMMARY_V1"] = "sg.ei.free-summary.v1";
    ProductId["SG_EI_GOLD_V1"] = "sg.ei.gold.v1";
    ProductId["SG_EI_LITE_V1"] = "sg.ei.lite.v1";
    ProductId["SG_EI_MC_CLASSIC_ADDON_V1"] = "sg.ei.mc-classic-addon.v1";
    ProductId["SG_EI_PLATINUM_V1"] = "sg.ei.platinum.v1";
    ProductId["SG_EI_PREMIER_100M_V1"] = "sg.ei.premier-100m.v1";
    ProductId["SG_EI_PREMIER_100M_V2"] = "sg.ei.premier-100m.v2";
    ProductId["SG_EI_PREMIER_10M_V1"] = "sg.ei.premier-10m.v1";
    ProductId["SG_EI_PREMIER_10M_V2"] = "sg.ei.premier-10m.v2";
    ProductId["SG_EI_PREMIER_15M_V1"] = "sg.ei.premier-15m.v1";
    ProductId["SG_EI_PREMIER_15M_V2"] = "sg.ei.premier-15m.v2";
    ProductId["SG_EI_PREMIER_200M_V1"] = "sg.ei.premier-200m.v1";
    ProductId["SG_EI_PREMIER_200M_V2"] = "sg.ei.premier-200m.v2";
    ProductId["SG_EI_PREMIER_20M_V1"] = "sg.ei.premier-20m.v1";
    ProductId["SG_EI_PREMIER_20M_V2"] = "sg.ei.premier-20m.v2";
    ProductId["SG_EI_PREMIER_25M_V1"] = "sg.ei.premier-25m.v1";
    ProductId["SG_EI_PREMIER_25M_V2"] = "sg.ei.premier-25m.v2";
    ProductId["SG_EI_PREMIER_2P5M_V1"] = "sg.ei.premier-2p5m.v1";
    ProductId["SG_EI_PREMIER_300M_V1"] = "sg.ei.premier-300m.v1";
    ProductId["SG_EI_PREMIER_300M_V2"] = "sg.ei.premier-300m.v2";
    ProductId["SG_EI_PREMIER_3M_V1"] = "sg.ei.premier-3m.v1";
    ProductId["SG_EI_PREMIER_400M_V1"] = "sg.ei.premier-400m.v1";
    ProductId["SG_EI_PREMIER_400M_V2"] = "sg.ei.premier-400m.v2";
    ProductId["SG_EI_PREMIER_500M_V1"] = "sg.ei.premier-500m.v1";
    ProductId["SG_EI_PREMIER_500M_V2"] = "sg.ei.premier-500m.v2";
    ProductId["SG_EI_PREMIER_50M_V1"] = "sg.ei.premier-50m.v1";
    ProductId["SG_EI_PREMIER_50M_V2"] = "sg.ei.premier-50m.v2";
    ProductId["SG_EI_PREMIER_5M_V1"] = "sg.ei.premier-5m.v1";
    ProductId["SG_EI_PREMIER_5M_V2"] = "sg.ei.premier-5m.v2";
    ProductId["SG_EI_PREMIER_600M_V1"] = "sg.ei.premier-600m.v1";
    ProductId["SG_EI_PREMIER_600M_V2"] = "sg.ei.premier-600m.v2";
    ProductId["SG_EI_PREMIER_7P5M_V1"] = "sg.ei.premier-7p5m.v1";
    ProductId["SG_EI_PREMIER_7P5M_V2"] = "sg.ei.premier-7p5m.v2";
    ProductId["SG_EI_PREMIER_SUMMARY_V1"] = "sg.ei.premier-summary.v1";
    ProductId["SG_EI_PRO_100K_V1"] = "sg.ei.pro-100k.v1";
    ProductId["SG_EI_PRO_100K_V2"] = "sg.ei.pro-100k.v2";
    ProductId["SG_EI_PRO_1P5M_V1"] = "sg.ei.pro-1p5m.v1";
    ProductId["SG_EI_PRO_1P5M_V2"] = "sg.ei.pro-1p5m.v2";
    ProductId["SG_EI_PRO_2P5M_V1"] = "sg.ei.pro-2p5m.v1";
    ProductId["SG_EI_PRO_2P5M_V2"] = "sg.ei.pro-2p5m.v2";
    ProductId["SG_EI_PRO_2P5M_V3"] = "sg.ei.pro-2p5m.v3";
    ProductId["SG_EI_PRO_300K_V1"] = "sg.ei.pro-300k.v1";
    ProductId["SG_EI_PRO_300K_V2"] = "sg.ei.pro-300k.v2";
    ProductId["SG_EI_PRO_700K_V1"] = "sg.ei.pro-700k.v1";
    ProductId["SG_EI_PRO_700K_V2"] = "sg.ei.pro-700k.v2";
    ProductId["SG_EI_PRO_SUMMARY_V1"] = "sg.ei.pro-summary.v1";
    ProductId["SG_EI_SILVER_V1"] = "sg.ei.silver.v1";
    ProductId["SG_EI_TRIAL_40K_V1"] = "sg.ei.trial-40k.v1";
    ProductId["SG_LVS_BOOTCAMP_V1"] = "sg.lvs.bootcamp.v1";
    ProductId["SG_LVS_IMPLEMENTATION_V1"] = "sg.lvs.implementation.v1";
    ProductId["SG_LVS_PREMIER_INSIGHTS_V1"] = "sg.lvs.premier.insights.v1";
    ProductId["SG_LVS_PRO_INSIGHTS_V1"] = "sg.lvs.pro.insights.v1";
    ProductId["SG_MC_ADVANCED_100K_V1"] = "sg.mc.advanced-100k.v1";
    ProductId["SG_MC_ADVANCED_10K_V1"] = "sg.mc.advanced-10k.v1";
    ProductId["SG_MC_ADVANCED_10M_V1"] = "sg.mc.advanced-10m.v1";
    ProductId["SG_MC_ADVANCED_1M_V1"] = "sg.mc.advanced-1m.v1";
    ProductId["SG_MC_ADVANCED_200K_V1"] = "sg.mc.advanced-200k.v1";
    ProductId["SG_MC_ADVANCED_20K_V1"] = "sg.mc.advanced-20k.v1";
    ProductId["SG_MC_ADVANCED_500K_V1"] = "sg.mc.advanced-500k.v1";
    ProductId["SG_MC_ADVANCED_50K_V1"] = "sg.mc.advanced-50k.v1";
    ProductId["SG_MC_ADVANCED_5M_V1"] = "sg.mc.advanced-5m.v1";
    ProductId["SG_MC_BASIC_100K_V1"] = "sg.mc.basic-100k.v1";
    ProductId["SG_MC_BASIC_10K_V1"] = "sg.mc.basic-10k.v1";
    ProductId["SG_MC_BASIC_10M_V1"] = "sg.mc.basic-10m.v1";
    ProductId["SG_MC_BASIC_1M_V1"] = "sg.mc.basic-1m.v1";
    ProductId["SG_MC_BASIC_200K_V1"] = "sg.mc.basic-200k.v1";
    ProductId["SG_MC_BASIC_20K_V1"] = "sg.mc.basic-20k.v1";
    ProductId["SG_MC_BASIC_500K_V1"] = "sg.mc.basic-500k.v1";
    ProductId["SG_MC_BASIC_50K_V1"] = "sg.mc.basic-50k.v1";
    ProductId["SG_MC_BASIC_5K_V1"] = "sg.mc.basic-5k.v1";
    ProductId["SG_MC_BASIC_5M_V1"] = "sg.mc.basic-5m.v1";
    ProductId["SG_MC_FREE_V1"] = "sg.mc.free.v1";
    ProductId["SG_X_EASE_30_BRONZE_V1"] = "sg.x.ease-30-bronze.v1";
    ProductId["SG_X_EASE_30_ESSENTIALS_100K_V1"] = "sg.x.ease-30-essentials-100k.v1";
    ProductId["SG_X_EASE_30_ESSENTIALS_40K_V1"] = "sg.x.ease-30-essentials-40k.v1";
    ProductId["SG_X_EASE_30_GOLD_V1"] = "sg.x.ease-30-gold.v1";
    ProductId["SG_X_EASE_30_PLATINUM_V1"] = "sg.x.ease-30-platinum.v1";
    ProductId["SG_X_EASE_30_PREMIER_10M_V1"] = "sg.x.ease-30-premier-10m.v1";
    ProductId["SG_X_EASE_30_PREMIER_15M_V1"] = "sg.x.ease-30-premier-15m.v1";
    ProductId["SG_X_EASE_30_PREMIER_20M_V1"] = "sg.x.ease-30-premier-20m.v1";
    ProductId["SG_X_EASE_30_PREMIER_25M_V1"] = "sg.x.ease-30-premier-25m.v1";
    ProductId["SG_X_EASE_30_PREMIER_2P5M_V1"] = "sg.x.ease-30-premier-2p5m.v1";
    ProductId["SG_X_EASE_30_PREMIER_50M_V1"] = "sg.x.ease-30-premier-50m.v1";
    ProductId["SG_X_EASE_30_PREMIER_5M_V1"] = "sg.x.ease-30-premier-5m.v1";
    ProductId["SG_X_EASE_30_PREMIER_7P5M_V1"] = "sg.x.ease-30-premier-7p5m.v1";
    ProductId["SG_X_EASE_30_PRO_100K_V1"] = "sg.x.ease-30-pro-100k.v1";
    ProductId["SG_X_EASE_30_PRO_1P5M_V1"] = "sg.x.ease-30-pro-1p5m.v1";
    ProductId["SG_X_EASE_30_PRO_2P5M_V1"] = "sg.x.ease-30-pro-2p5m.v1";
    ProductId["SG_X_EASE_30_PRO_300K_V1"] = "sg.x.ease-30-pro-300k.v1";
    ProductId["SG_X_EASE_30_PRO_700K_V1"] = "sg.x.ease-30-pro-700k.v1";
    ProductId["SG_X_EASE_30_SILVER_V1"] = "sg.x.ease-30-silver.v1";
    ProductId["SG_X_EMAIL_TESTING_100_V1"] = "sg.x.email-testing-100.v1";
    ProductId["SG_X_EMAIL_TESTING_30_V1"] = "sg.x.email-testing-30.v1";
    ProductId["SG_X_EMAIL_TESTING_60_V1"] = "sg.x.email-testing-60.v1";
    ProductId["SG_X_IP_V1"] = "sg.x.ip.v1";
    ProductId["SG_X_IP_V2"] = "sg.x.ip.v2";
    ProductId["SG_X_PLACEHOLDER_V1"] = "sg.x.placeholder.v1";
    ProductId["SG_MC_CUSTOM_PRICING_V1"] = "sg.mc.custom-pricing.v1";
    ProductId["SG_EI_CUSTOM_PRICING_V1"] = "sg.ei.custom-pricing.v1";
    ProductId["SG_EI_PRO_2P5MLEGACY_V1"] = "sg.ei.pro-2p5mlegacy.v1";
    ProductId["SG_X_EMAIL_TESTING_0_V1"] = "no-additional-email-testing-credits";
    ProductId["SG_MC_CLASSIC_TRIAL_DISCOUNT_V1"] = "sg.mc.classic-trial-discount.v1";
})(ProductId || (ProductId = {}));

function isAccountVerified(signupStatus) {
    // Defaulting to true because we only want isVerified to be false if we 100% know it is false.
    // Without data, we can't know. We don't want to send messaging about account verification
    // unless we know they are unverified
    if (!signupStatus) {
        return true;
    }
    var email_complete = signupStatus.email_complete, email_required = signupStatus.email_required, mfa_complete = signupStatus.mfa_complete, mfa_required = signupStatus.mfa_required, whitelabel_complete = signupStatus.whitelabel_complete, whitelabel_required = signupStatus.whitelabel_required;
    if (email_required && !email_complete) {
        return false;
    }
    if (mfa_required && !mfa_complete) {
        return false;
    }
    if (whitelabel_required && !whitelabel_complete) {
        return false;
    }
    return true;
}
function mapScopesToTraits(scopes) {
    var hasTneAccess = (scopes && scopes.scopes && scopes.scopes.includes('marketing.read')) ||
        false;
    return {
        hasTneAccess: hasTneAccess,
    };
}
function mapSignupStatusToTraits(signupStatus) {
    var isVerified = isAccountVerified(signupStatus);
    return {
        isVerified: isVerified,
    };
}
function mapOesAccountToTraits(oesAccountDto) {
    var traits = {
        eiPlan: null,
        mcPlan: null,
        legacyMcPlan: null,
        legacyMCDiscountEligible: false,
        legacyMCDiscountActive: false,
    };
    if (!oesAccountDto) {
        return traits;
    }
    var offerings = oesAccountDto.offerings, entitlements = oesAccountDto.entitlements;
    var eiPlanName = /^sg\.ei\..+\.v\d+$/i;
    var mcPlanName = /^sg\.mc\..+\.v\d+$/i;
    offerings.forEach(function (offering) {
        if (offering.name === ProductId.SG_MC_CLASSIC_TRIAL_DISCOUNT_V1) {
            var endDate = new Date(offering.end_date);
            var dateFormatOptions = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            };
            var formattedEndDate = endDate.toLocaleDateString('en-US', dateFormatOptions);
            traits.legacyMCDiscountActive = true;
            traits.legacyMCDiscountEndDate = offering.end_date;
            traits.legacyMCDiscountEndDateFormatted = formattedEndDate;
            return;
        }
        if (offering.name === ProductId.SG_EI_MC_CLASSIC_ADDON_V1) {
            traits.legacyMcPlan = offering.name;
            return;
        }
        if (eiPlanName.test(offering.name) && offering.type === 'package') {
            traits.eiPlan = offering.name;
            return;
        }
        if (mcPlanName.test(offering.name) && offering.type === 'package') {
            traits.mcPlan = offering.name;
            return;
        }
    });
    traits.legacyMCDiscountEligible =
        entitlements.compat_mc_classic_trial_eligible || false;
    return traits;
}
function mapAccountToTraits(account) {
    if (!account) {
        return {};
    }
    return {
        accountType: account.type,
        isResellerCustomer: account.is_reseller_customer,
    };
}
function mapUsernameToTraits(username) {
    if (!username) {
        return {};
    }
    return {
        userId: username.user_id,
    };
}
function mapPackageToTraits(userPackage) {
    if (!userPackage) {
        return {};
    }
    return {
        package: userPackage.name,
    };
}
function mapFeatureTogglesToTraits(featureToggles) {
    if (!featureToggles) {
        return {};
    }
    var featureTogglesCsv = featureToggles
        .map(function (ft) { return ft.app_name + "-" + ft.feature_name; })
        .join(',');
    return {
        featureToggles: featureTogglesCsv,
    };
}

function fetchUserTraits(authToken) {
    return __awaiter(this, void 0, Promise, function () {
        var usernamePromise, accountPromise, featureTogglesPromise, signupStatusPromise, userPackagePromise, scopesPromise, oesAccountPromise, username, account, featureToggles, signupStatus, userPackage, scopes, oesAccount, usernameTraits, featureTogglesTraits, packageTraits, accountTraits, traitsFromSignupStatus, traitsFromScopes, traitsFromOesAccount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    http.addAuthHeader(authToken);
                    usernamePromise = api.getUsername().catch(function () { return undefined; });
                    accountPromise = api.getUserAccount().catch(function () { return undefined; });
                    featureTogglesPromise = api.getFeatureToggles().catch(function () { return undefined; });
                    signupStatusPromise = api.getSignupStatus().catch(function () { return undefined; });
                    userPackagePromise = api.getUserPackage().catch(function () { return undefined; });
                    scopesPromise = api.getScopes().catch(function () { return undefined; });
                    oesAccountPromise = api.getOesAccount().catch(function () { return undefined; });
                    return [4 /*yield*/, usernamePromise];
                case 1:
                    username = _a.sent();
                    return [4 /*yield*/, accountPromise];
                case 2:
                    account = _a.sent();
                    return [4 /*yield*/, featureTogglesPromise];
                case 3:
                    featureToggles = _a.sent();
                    return [4 /*yield*/, signupStatusPromise];
                case 4:
                    signupStatus = _a.sent();
                    return [4 /*yield*/, userPackagePromise];
                case 5:
                    userPackage = _a.sent();
                    return [4 /*yield*/, scopesPromise];
                case 6:
                    scopes = _a.sent();
                    return [4 /*yield*/, oesAccountPromise];
                case 7:
                    oesAccount = _a.sent();
                    usernameTraits = mapUsernameToTraits(username);
                    featureTogglesTraits = mapFeatureTogglesToTraits(featureToggles);
                    packageTraits = mapPackageToTraits(userPackage);
                    accountTraits = mapAccountToTraits(account);
                    traitsFromSignupStatus = mapSignupStatusToTraits(signupStatus);
                    traitsFromScopes = mapScopesToTraits(scopes);
                    traitsFromOesAccount = mapOesAccountToTraits(oesAccount);
                    return [2 /*return*/, __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, featureTogglesTraits), packageTraits), usernameTraits), accountTraits), traitsFromSignupStatus), traitsFromScopes), traitsFromOesAccount)];
            }
        });
    });
}

function identify(identity) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, Promise, function () {
        var authToken, traits, baseTraits, userId, allTraits_1, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    authToken = identity.authToken, traits = identity.traits;
                    if (!authToken) {
                        // If no auth token was passed, perform an anonymous identify.
                        // Segment will generate an anonymousId to track the session.
                        (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.identify(traits);
                        (_b = window.DD_RUM) === null || _b === void 0 ? void 0 : _b.setUser(__assign({}, traits));
                        return [2 /*return*/];
                    }
                    validate();
                    return [4 /*yield*/, fetchUserTraits(authToken)];
                case 1:
                    baseTraits = _e.sent();
                    userId = baseTraits.userId;
                    setOptimizelyCustomAttributes(baseTraits);
                    // We have to know who the user is for authed identify to behave
                    // as expected. Don't send anything if we don't have a user Id.
                    // We could send the traits we were able to pull anonymously
                    // but in most scenarios if we are unable to load the user Id,
                    // the other calls will have failed as well.
                    if (!userId) {
                        return [2 /*return*/];
                    }
                    allTraits_1 = __assign(__assign({}, baseTraits), traits);
                    // Don't send any null or undefined traits to segment
                    Object.keys(allTraits_1).forEach(function (key) {
                        var value = allTraits_1[key];
                        if (value === null || value === undefined) {
                            delete allTraits_1[key];
                        }
                    });
                    (_c = window.analytics) === null || _c === void 0 ? void 0 : _c.identify(userId.toString(), allTraits_1);
                    (_d = window.DD_RUM) === null || _d === void 0 ? void 0 : _d.setUser(__assign({ id: userId.toString() }, allTraits_1));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _e.sent();
                    console.error('Failed to identify user', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function validate() {
    if (!config || !config.apiBaseUrl) {
        throw new Error("Cannot make auth'd calls without an apiBaseUrl. You'll need to re-init the analtyics config.");
    }
}
// This is a temporary home for setting Optimizely custom attributes
// for CL-182 since we haven't built out the experimentation module yet.
// It was coincidence that we were able to use traits to build the
// attributes for this experiement, but may not be a pattern to
// follow going forward. Traits can be sent verbatim as attributes,
// but we'll probably avoid *deriving* attributes from traits.
function setOptimizelyCustomAttributes(userTraits) {
    // CL-182 -- set Optimizely Custom Attributes for the User
    var eiPlan = userTraits.eiPlan, mcPlan = userTraits.mcPlan;
    var attributes = {
        isFreeMC: mcPlan && mcPlan.includes('free'),
        isFreeEI: eiPlan && (eiPlan.includes('free') || eiPlan.includes('trial')),
    };
    window.optimizely = window.optimizely || [];
    window.optimizely.push({
        type: 'user',
        attributes: attributes,
    });
}

/** Add filters to this list to enable them. */
var eventFilters = [];
var shouldDiscardEvent = function (event) {
    return eventFilters.some(function (filter) { return filter(event); });
};

var apiKeyRegex = /SG(\.[^.]+){2,}/g;
var ipRegex = /(\d{1,3}\.(?:\d{1,3}|\*(?=\.\*))\.(?:\d{1,3}|\*(?=\.\*))\.(?:\d{1,3}|\*)(?:\/\d{1,2})?(?:\[.*?\])?)/g;
var IP_REDACTED = 'IP_REDACTED';
var API_KEY_REDACTED = 'API_KEY_REDACTED';
/*
 * Add more redactions here and they'll run against all editable event fields.
 */
var redactions = [
    {
        searchValue: apiKeyRegex,
        replaceValue: API_KEY_REDACTED,
    },
    {
        searchValue: ipRegex,
        replaceValue: IP_REDACTED,
    },
];
var redactData = function (sourceString, searchValue, replaceValue) {
    if (!sourceString) {
        return sourceString;
    }
    return sourceString.replace(searchValue, replaceValue);
};
/** Redacts sensitive data from all editable fields of a RUM event.
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#modify-the-content-of-a-rum-event
 */
var redactSensitiveData = function (event) {
    redactions.forEach(function (redaction) {
        var _a, _b;
        var searchValue = redaction.searchValue, replaceValue = redaction.replaceValue;
        event.view.url = redactData(event.view.url, searchValue, replaceValue);
        if (event.view.referrer) {
            event.view.referrer = redactData(event.view.referrer, searchValue, replaceValue);
        }
        if (event.type === 'error') {
            var error = event.error;
            error.message = redactData(error.message, searchValue, replaceValue);
            if (error.stack) {
                error.stack = redactData(error.stack, searchValue, replaceValue);
            }
            if (error.resource) {
                error.resource.url = redactData(error.resource.url, searchValue, replaceValue);
            }
        }
        if (event.type === 'resource') {
            event.resource.url = redactData(event.resource.url, searchValue, replaceValue);
        }
        if (event.type === 'action') {
            if ((_b = (_a = event.action) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.name) {
                event.action.target.name = redactData(event.action.target.name, searchValue, replaceValue);
            }
        }
    });
};

var REDACTED_PATH_PARAM = ':REDACTED';
var sendgridApiHosts = [
    'api.sendgrid.com',
    'api.staging.sendgrid.com',
];
var httpResourceTypes = ['xhr', 'fetch'];

var numberRegex = /(?<=\/)(\d+)(?=\/|\?|$)/g;
var emailRegex = /(?<=\/)(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]+@[A-Z0-9][A-Z0-9\-]*(\.[A-Z]{2,})+)(?=\/|\?|$)/gi;
var uuidv4Regex = /(?<=\/)([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?=\/|\?|$)/gi;
var redactApiKeyRegex = /(?<=\/api_keys\/)[^\/]*/;
var redactBillingInvoiceRegex = /(?<=\/billing\/invoice\/)[^\/]*/;
var redactVerifySenderRegex = /(?<=\/verified_senders\/verify\/)[^\/]*/;
var redactTeammateRegex = /(?<=\/teammates\/)[^\/]*/;
var redactSubusersRegex = /(?<=\/subusers\/)[^\/]*/;
var redactOfferingsRegex = /(?<=\/offerings\/)[^\/]*/;
var redactDynamicTemplateRegex = /(?<=\/dynamic_templates\/ui\/)[^\/]*/;
var redactPaymentRegex = /(?<=\/dashboard\/payment\/)([^\/]*)\/([^\/]*)/;

var redactPathParams = function (urlString) {
    var url = new URL(urlString);
    url.pathname = url.pathname
        .replace(numberRegex, REDACTED_PATH_PARAM)
        .replace(emailRegex, REDACTED_PATH_PARAM)
        .replace(uuidv4Regex, REDACTED_PATH_PARAM);
    return url.toString();
};
var redactSpecificAPIPathParams = function (urlString) {
    var url = new URL(urlString);
    url.pathname = url.pathname
        .replace(redactApiKeyRegex, REDACTED_PATH_PARAM)
        .replace(redactBillingInvoiceRegex, REDACTED_PATH_PARAM)
        .replace(redactVerifySenderRegex, REDACTED_PATH_PARAM)
        .replace(redactTeammateRegex, REDACTED_PATH_PARAM)
        .replace(redactSubusersRegex, REDACTED_PATH_PARAM)
        .replace(redactOfferingsRegex, REDACTED_PATH_PARAM);
    return url.toString();
};
var redactSpecificViewPathParams = function (urlString) {
    var url = new URL(urlString);
    url.pathname = url.pathname
        .replace(redactDynamicTemplateRegex, REDACTED_PATH_PARAM)
        .replace(redactPaymentRegex, REDACTED_PATH_PARAM + "/" + REDACTED_PATH_PARAM);
    return url.toString();
};
var redactUrlPathParams = function (event) {
    if (event.type === 'resource') {
        var host = new URL(event.resource.url).host;
        var shouldRedactPathParams = httpResourceTypes.includes(event.resource.type) &&
            sendgridApiHosts.includes(host);
        if (shouldRedactPathParams) {
            event.resource.url = redactPathParams(event.resource.url);
            event.resource.url = redactSpecificAPIPathParams(event.resource.url);
        }
    }
    if (event.type === 'view') {
        event.view.url = redactPathParams(event.view.url);
        event.view.url = redactSpecificViewPathParams(event.view.url);
    }
};

var REDACTED_PARAM = 'REDACTED';
/** Redacts search params from a URL
 * A query string is a place we can leak sensitive info. Some examples are:
 * One time use tokens (password reset, 2FA setup links, etc)
 * Filter/search parameters (email activity advanced search)
 */
var redactSearchParams = function (url) {
    try {
        var outputUrl_1 = new URL(url);
        outputUrl_1.searchParams.forEach(function (_, key) {
            outputUrl_1.searchParams.set(key, REDACTED_PARAM);
        });
        return outputUrl_1.toString();
    }
    catch (_a) {
        return '';
    }
};
/** Redacts search param values from all editable URLs of a RUM event.
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#modify-the-content-of-a-rum-event
 */
var redactUrlSearchParams = function (event) {
    var _a;
    event.view.url = redactSearchParams(event.view.url);
    if (event.view.referrer) {
        event.view.referrer = redactSearchParams(event.view.referrer);
    }
    if (event.type === 'resource') {
        event.resource.url = redactSearchParams(event.resource.url);
    }
    if (event.type === 'error' && ((_a = event.error.resource) === null || _a === void 0 ? void 0 : _a.url)) {
        event.error.resource.url = redactSearchParams(event.error.resource.url);
    }
};

/** Add event processors to this list to enable them. */
var eventProcessors = [
    redactSensitiveData,
    redactUrlSearchParams,
    redactUrlPathParams,
];
var processEvent = function (event) {
    eventProcessors.forEach(function (processor) { return processor(event); });
};

/**
 * Executes the client's beforeSend function followed by internal
 * event processing if the event was not discarded.
 * @param clientBeforeSend beforeSend function provided by client during initialization
 * @returns The final beforeSend function used to initialize Datadog RUM
 */
function composeBeforeSend(clientBeforeSend) {
    var composedBeforeSend = function (event, context) {
        try {
            var isBeforeSendFunction = typeof clientBeforeSend === 'function';
            var isEventDiscardedByClient = isBeforeSendFunction && clientBeforeSend(event, context) === false;
            var isEventDiscarded = isEventDiscardedByClient || shouldDiscardEvent(event);
            if (isEventDiscarded) {
                return false;
            }
            processEvent(event);
        }
        catch (_a) {
            return false;
        }
    };
    return composedBeforeSend;
}

function initializeDatadogRum(options) {
    datadogRum.init(__assign(__assign({}, options), { beforeSend: composeBeforeSend(options.beforeSend) }));
}

// This snippet is adapted from the segment documentation and is the
// recommended approach for bootstrapping.
// https://segment.com/docs/sources/website/analytics.js/quickstart/
function loadSegment(writeKey, options) {
    // Create a queue, but don't obliterate an existing one!
    var analytics = (window.analytics = window.analytics || []);
    // If the real analytics.js is already on the page return.
    if (analytics.initialize) {
        return;
    }
    // If the snippet was invoked already show an error.
    if (analytics.invoked) {
        if (window.console && console.error) {
            console.error('Segment snippet included twice.');
        }
        return;
    }
    // Invoked flag, to make sure the snippet
    // is never invoked twice.
    analytics.invoked = true;
    // A list of the methods in Analytics.js to stub.
    analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
    ];
    // Define a factory to create stubs. These are placeholders
    // for methods in Analytics.js so that you never have to wait
    // for it to load to actually record data. The `method` is
    // stored as the first argument, so we can replay the data.
    analytics.factory = function (method) {
        return function () {
            var args = Array.prototype.slice.call(arguments);
            args.unshift(method);
            if (analytics.push) {
                analytics.push(args);
            }
            return analytics;
        };
    };
    // For each of our methods, generate a queueing stub.
    for (var i = 0; i < analytics.methods.length; i++) {
        var key = analytics.methods[i];
        analytics[key] = analytics.factory(key);
    }
    // Define a method to load Analytics.js from our CDN,
    // and that will be sure to only ever load it once.
    analytics.load = function (key, options) {
        // Create an async script element based on your key.
        var script = document.createElement('script');
        script.id = 'segment-analytics-js';
        script.type = 'text/javascript';
        script.async = true;
        script.src =
            'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';
        // Insert our script next to the first script element.
        var first = document.getElementsByTagName('script')[0];
        first.parentNode.insertBefore(script, first);
        analytics._loadOptions = options;
    };
    // Add a version to keep track of what's in the wild.
    analytics.SNIPPET_VERSION = '4.1.0';
    // Load Analytics.js with your key, which will automatically
    // load the tools you've enabled for your account. Boosh!
    analytics.load(writeKey, options);
}

function init(options) {
    try {
        validateAnalytics(options);
        mergeGlobalOptions(options);
        loadSegment(options.segmentApiKey);
        if (options.datadogRum) {
            initializeDatadogRum(options.datadogRum);
        }
    }
    catch (error) {
        console.error('Failed to initialize analytics', error);
    }
}
/**
 * validates the required defaults for Bloodhound and defaults particular to analytics
 * @param options
 */
function validateAnalytics(options) {
    if (!options || !options.segmentApiKey) {
        throw new Error("segmentApiKey is required");
    }
}

function getUserTraits() {
    if (!window.analytics ||
        !window.analytics.user ||
        !window.analytics.user().traits) {
        return {};
    }
    var userTraits = window.analytics.user().traits() || {};
    return Object.keys(userTraits).reduce(function (acc, trait) {
        var key = "trait_" + trait;
        acc[key] = userTraits[trait];
        return acc;
    }, {});
}

function page(data) {
    if (data === void 0) { data = {}; }
    var _a;
    try {
        var userTraits = getUserTraits();
        var optionalProperties = data.properties ? data.properties : {};
        var combinedProperties = __assign(__assign({}, userTraits), optionalProperties);
        (_a = window === null || window === void 0 ? void 0 : window.analytics) === null || _a === void 0 ? void 0 : _a.page(data.name, combinedProperties);
    }
    catch (error) {
        console.error('Failed to track page event.', error);
    }
}

/**
 * Use this function to reset a user’s identity to an anonymous state after they have logged out.
 */
function resetIdentity() {
    var _a, _b;
    try {
        (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.reset();
        (_b = window.DD_RUM) === null || _b === void 0 ? void 0 : _b.clearUser();
    }
    catch (_c) {
        console.warn('Failed to reset analytics identity');
    }
}

function track(data) {
    var _a, _b;
    var defaultProperties = {
        page: null,
        location: null,
        section: null,
        subsection: null,
        eventType: null,
        elementType: null,
    };
    try {
        if (!data) {
            console.warn('Data must be passed to the track event');
            return;
        }
        if (!data.event) {
            console.warn('Event name is required');
            return;
        }
        var userTraits = getUserTraits();
        var optionalProperties = data.properties ? data.properties : {};
        var combinedProperties = __assign(__assign(__assign({}, defaultProperties), userTraits), optionalProperties);
        (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.track(data.event, combinedProperties);
        (_b = window.DD_RUM) === null || _b === void 0 ? void 0 : _b.addAction(data.event, data.properties);
    }
    catch (error) {
        console.log('Failed to track event', error);
    }
    finally {
        // Generally used to give the browser time to make outbound requests
        // (send the events) before a redirect. We want to run this even if
        // tracking fails because tracking is non critical behavior.
        if (data.callback) {
            window.setTimeout(function () { return data.callback(); }, 300);
        }
    }
}

function trackLink(data) {
    var _a, _b;
    var defaultProperties = {
        page: null,
        location: null,
        section: null,
        subsection: null,
        eventType: null,
        elementType: null,
    };
    try {
        if (!data) {
            console.warn('Data must be passed to the trackLink event');
            return;
        }
        if (!data.event) {
            console.warn('Event name is required for trackLink');
            return;
        }
        if (!data.element) {
            console.warn('An element is required for trackLink');
            return;
        }
        var userTraits = getUserTraits();
        var optionalProperties = data.properties ? data.properties : {};
        var combinedProperties = __assign(__assign(__assign({}, defaultProperties), userTraits), optionalProperties);
        (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.trackLink(data.element, data.event, combinedProperties);
        (_b = window.DD_RUM) === null || _b === void 0 ? void 0 : _b.addAction(data.event, data.properties);
    }
    catch (error) {
        console.log('Failed to track event', error);
    }
}

var analytics = {
    identify: identify,
    init: init,
    page: page,
    track: track,
    trackLink: trackLink,
    configure: configure,
    resetIdentity: resetIdentity,
};

/**
 * Get ExperimentState object from optimizely
 *   - https://developers.optimizely.com/x/solutions/javascript/reference/index.html#function_getexperimentstates
 * @param {string} experimentId Optimizely Experiment Id
 * @returns {ExperimentState|Object} Optimizely Experiment state, or an empty object if there is none
 */
function getExperimentState(experimentId) {
    try {
        var optimizely = window.optimizely;
        if (!optimizely) {
            return {};
        }
        var state = optimizely.get('state');
        var experimentStates = state && state.getExperimentStates();
        return _get(experimentStates, experimentId, {});
    }
    catch (error) {
        console.error('Error getting experiment state', error);
    }
}

/**
 * Given an experiment and variation, is the user in the supplied variation?
 * @param {string} experimentId Optimizely Experiment Id
 * @param {string} variationId Optimizely Experiment Variation Id
 * @returns {boolean} is the user bucketed into the variation supplied?
 */
var isUserInVariation = function (experimentId, variationId) {
    return !experimentId || !variationId
        ? false
        : _get(getExperimentState(experimentId), 'variation.id', '') ===
            variationId;
};

var getEmailValidationKey = function (apiKeys) {
    return !!apiKeys.find(function (apiKey) {
        var subScope = 'validations.email';
        return (!!apiKey.scopes &&
            !!apiKey.scopes.find(function (scope) { return scope.indexOf(subScope) !== -1; }));
    });
};
var getEmailApiPlan = function (oesAccount) {
    return oesAccount.offerings.find(function (offering) {
        var eiPlanName = /^sg\.ei\..+\.v\d+$/i;
        return eiPlanName.test(offering.name) && offering.type === 'package';
    });
};

var _a;
var notificationExperimentPlans = (_a = {},
    _a[ProductId.SG_EI_SILVER_V1] = ProductId.SG_EI_SILVER_V1,
    _a[ProductId.SG_EI_GOLD_V1] = ProductId.SG_EI_GOLD_V1,
    _a[ProductId.SG_EI_PLATINUM_V1] = ProductId.SG_EI_PLATINUM_V1,
    _a[ProductId.SG_EI_PREMIER_2P5M_V1] = ProductId.SG_EI_PREMIER_2P5M_V1,
    _a[ProductId.SG_EI_PREMIER_3M_V1] = ProductId.SG_EI_PREMIER_3M_V1,
    _a[ProductId.SG_EI_PREMIER_5M_V1] = ProductId.SG_EI_PREMIER_5M_V1,
    _a[ProductId.SG_EI_PREMIER_5M_V2] = ProductId.SG_EI_PREMIER_5M_V2,
    _a[ProductId.SG_EI_PREMIER_7P5M_V1] = ProductId.SG_EI_PREMIER_7P5M_V1,
    _a[ProductId.SG_EI_PREMIER_7P5M_V2] = ProductId.SG_EI_PREMIER_7P5M_V2,
    _a[ProductId.SG_EI_PREMIER_10M_V1] = ProductId.SG_EI_PREMIER_10M_V1,
    _a[ProductId.SG_EI_PREMIER_10M_V2] = ProductId.SG_EI_PREMIER_10M_V2,
    _a[ProductId.SG_EI_PREMIER_15M_V1] = ProductId.SG_EI_PREMIER_15M_V1,
    _a[ProductId.SG_EI_PREMIER_15M_V2] = ProductId.SG_EI_PREMIER_15M_V2,
    _a[ProductId.SG_EI_PREMIER_20M_V1] = ProductId.SG_EI_PREMIER_20M_V1,
    _a[ProductId.SG_EI_PREMIER_20M_V2] = ProductId.SG_EI_PREMIER_20M_V2,
    _a[ProductId.SG_EI_PREMIER_25M_V1] = ProductId.SG_EI_PREMIER_25M_V1,
    _a[ProductId.SG_EI_PREMIER_25M_V2] = ProductId.SG_EI_PREMIER_25M_V2,
    _a[ProductId.SG_EI_PREMIER_50M_V1] = ProductId.SG_EI_PREMIER_50M_V1,
    _a[ProductId.SG_EI_PREMIER_50M_V2] = ProductId.SG_EI_PREMIER_50M_V2,
    _a[ProductId.SG_EI_PREMIER_100M_V1] = ProductId.SG_EI_PREMIER_100M_V1,
    _a[ProductId.SG_EI_PREMIER_100M_V2] = ProductId.SG_EI_PREMIER_100M_V2,
    _a[ProductId.SG_EI_PREMIER_200M_V1] = ProductId.SG_EI_PREMIER_200M_V1,
    _a[ProductId.SG_EI_PREMIER_200M_V2] = ProductId.SG_EI_PREMIER_200M_V2,
    _a[ProductId.SG_EI_PREMIER_300M_V1] = ProductId.SG_EI_PREMIER_300M_V1,
    _a[ProductId.SG_EI_PREMIER_300M_V2] = ProductId.SG_EI_PREMIER_300M_V2,
    _a[ProductId.SG_EI_PREMIER_400M_V1] = ProductId.SG_EI_PREMIER_400M_V1,
    _a[ProductId.SG_EI_PREMIER_400M_V2] = ProductId.SG_EI_PREMIER_400M_V2,
    _a[ProductId.SG_EI_PREMIER_500M_V1] = ProductId.SG_EI_PREMIER_500M_V1,
    _a[ProductId.SG_EI_PREMIER_500M_V2] = ProductId.SG_EI_PREMIER_500M_V2,
    _a[ProductId.SG_EI_PREMIER_600M_V1] = ProductId.SG_EI_PREMIER_600M_V1,
    _a[ProductId.SG_EI_PREMIER_600M_V2] = ProductId.SG_EI_PREMIER_600M_V2,
    _a[ProductId.SG_EI_PRO_100K_V1] = ProductId.SG_EI_PRO_100K_V1,
    _a[ProductId.SG_EI_PRO_100K_V2] = ProductId.SG_EI_PRO_100K_V2,
    _a[ProductId.SG_EI_PRO_300K_V1] = ProductId.SG_EI_PRO_300K_V1,
    _a[ProductId.SG_EI_PRO_300K_V2] = ProductId.SG_EI_PRO_300K_V2,
    _a[ProductId.SG_EI_PRO_700K_V1] = ProductId.SG_EI_PRO_700K_V1,
    _a[ProductId.SG_EI_PRO_700K_V2] = ProductId.SG_EI_PRO_700K_V2,
    _a[ProductId.SG_EI_PRO_1P5M_V1] = ProductId.SG_EI_PRO_1P5M_V1,
    _a[ProductId.SG_EI_PRO_1P5M_V2] = ProductId.SG_EI_PRO_1P5M_V2,
    _a[ProductId.SG_EI_PRO_2P5M_V1] = ProductId.SG_EI_PRO_2P5M_V1,
    _a[ProductId.SG_EI_PRO_2P5M_V2] = ProductId.SG_EI_PRO_2P5M_V2,
    _a[ProductId.SG_EI_PRO_2P5M_V3] = ProductId.SG_EI_PRO_2P5M_V3,
    _a[ProductId.SG_EI_PRO_2P5MLEGACY_V1] = ProductId.SG_EI_PRO_2P5MLEGACY_V1,
    _a);

function shouldDisplayNCExperimentAsync() {
    return __awaiter(this, void 0, void 0, function () {
        var getApiKeysPromise, getEIPlanPromise, _a, apiKeys, oesAccount, hasEmailValidationApiKey_1, emailApiPlan_1, ncExperimentPromise, err_1;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    getApiKeysPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                        var apiKeysData, apiKeyScopesData;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, getApiKeys()];
                                case 1:
                                    apiKeysData = _a.sent();
                                    apiKeyScopesData = apiKeysData.result.map(function (apiKey) {
                                        return getApiKey(apiKey.api_key_id);
                                    });
                                    return [2 /*return*/, Promise.all(apiKeyScopesData)];
                            }
                        });
                    }); })();
                    getEIPlanPromise = getOesAccount();
                    return [4 /*yield*/, Promise.all([
                            getApiKeysPromise,
                            getEIPlanPromise,
                        ])];
                case 1:
                    _a = _b.sent(), apiKeys = _a[0], oesAccount = _a[1];
                    hasEmailValidationApiKey_1 = getEmailValidationKey(apiKeys);
                    emailApiPlan_1 = getEmailApiPlan(oesAccount);
                    ncExperimentPromise = new Promise(function (resolve, reject) {
                        var counter = 0;
                        var appcuesInterval = setInterval(function () { return checkForAppcues(); }, 300);
                        var checkForAppcues = function () {
                            counter++;
                            if (window.Appcues &&
                                window.optimizely &&
                                window.AppcuesWidget) {
                                var isEligibleForNotificationCenter = emailApiPlan_1 &&
                                    !!notificationExperimentPlans[emailApiPlan_1.name] &&
                                    !hasEmailValidationApiKey_1;
                                window.optimizely.push({
                                    type: 'user',
                                    attributes: {
                                        isEligibleForNotificationCenter: isEligibleForNotificationCenter,
                                    },
                                });
                                resolve(isEligibleForNotificationCenter);
                                return clearInterval(appcuesInterval);
                            }
                            if (counter > 90) {
                                // If appcues, optimizely, or appcuesWidget fails we want to clear the interval to prevent it from running indefinitely
                                resolve(false);
                                return clearInterval(appcuesInterval);
                            }
                        };
                    });
                    return [2 /*return*/, ncExperimentPromise];
                case 2:
                    err_1 = _b.sent();
                    console.error('Failed to determine if user is in experiment', err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}

var experiments = {
    isUserInVariation: isUserInVariation,
    getExperimentState: getExperimentState,
    shouldDisplayNCExperimentAsync: shouldDisplayNCExperimentAsync,
};

export { analytics, experiments };
